import { Reveal, Overline } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "You send an enquiry",
    text: "Share your dates, your vision and any details you can — big or small. We reply within one day, often the same day.",
  },
  {
    n: "02",
    title: "We craft a bespoke proposal",
    text: "Menus, wellness, concierge, arrival details — thoughtfully tailored to your party, dietary needs and the season.",
  },
  {
    n: "03",
    title: "Your stay is prepared",
    text: "Fresh flowers, a stocked pantry, chilled champagne, fire prepared, ambient lighting — the lodge waiting for you.",
  },
  {
    n: "04",
    title: "You arrive, we take care",
    text: "Discreet, attentive, entirely behind the scenes. All you have to do is be fully present with the people you love.",
  },
];

export default function WhatToExpect() {
  return (
    <section
      id="what-to-expect"
      className="relative bg-bg py-24 md:py-32"
      data-testid="what-to-expect"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-4">
            <Reveal>
              <Overline>What to expect</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-ink text-3xl md:text-5xl lg:text-6xl leading-[1.05]">
                A calm, considered <em className="italic text-metallic-gold">welcome</em>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-sans text-base text-ink/60 max-w-sm leading-relaxed">
                From the moment you enquire to the moment you leave, everything moves
                quietly around you.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8 lg:pl-10">
            <div className="divide-y divide-white/10 border-t border-white/10">
              {STEPS.map((s, i) => (
                <Reveal key={s.n} delay={i * 0.06}>
                  <div
                    data-testid={`expect-step-${s.n}`}
                    className="grid grid-cols-12 gap-6 md:gap-10 py-8 md:py-10"
                  >
                    <span className="col-span-2 md:col-span-1 font-serif text-2xl md:text-3xl text-gold/70">
                      {s.n}
                    </span>
                    <div className="col-span-10 md:col-span-11">
                      <h3 className="font-serif font-light text-ink text-2xl md:text-3xl leading-tight">
                        {s.title}
                      </h3>
                      <p className="mt-3 font-sans text-base text-ink/60 max-w-2xl leading-relaxed">
                        {s.text}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
